// Apariencia de la cuenta (2026-09-10): tema + letra + tamaño + modo viajan
// con el usuario en `profiles.apariencia` para que al entrar desde otro
// teléfono o computador se vea igual. El dispositivo sigue siendo el espejo
// síncrono (localStorage, lo lee el script inline de index.html antes de que
// React monte); la cuenta es la fuente al iniciar sesión.
import { supabase } from './supabase';
import { normalizarTema } from './tema';
import { normalizarLetra } from './letra';
import { normalizarTexto } from './texto';

export const MODOS = ['claro', 'oscuro'];

// Re-valida cada campo contra su catálogo: un jsonb adulterado cae al
// default de cada uno. `modo` null = no elegido (se respeta el sistema).
export function normalizarApariencia(obj) {
  const o = obj && typeof obj === 'object' ? obj : {};
  return {
    tema:  normalizarTema(o.tema),
    letra: normalizarLetra(o.letra),
    texto: normalizarTexto(o.texto),
    modo:  MODOS.includes(o.modo) ? o.modo : null,
  };
}

export function aparienciaIgual(a, b) {
  const x = normalizarApariencia(a), y = normalizarApariencia(b);
  return x.tema === y.tema && x.letra === y.letra && x.texto === y.texto && x.modo === y.modo;
}

// Lee la apariencia guardada en la cuenta. `null` si nunca se guardó o si
// falla (best-effort: la app arranca igual con lo del dispositivo).
export async function cargarApariencia(userId) {
  if (!userId) return null;
  try {
    const { data, error } = await supabase
      .from('profiles')
      .select('apariencia')
      .eq('user_id', userId)
      .maybeSingle();
    if (error || !data?.apariencia) return null;
    return normalizarApariencia(data.apariencia);
  } catch {
    return null;
  }
}

export async function guardarApariencia(userId, apariencia) {
  if (!userId) return false;
  try {
    const { error } = await supabase
      .from('profiles')
      .update({ apariencia: normalizarApariencia(apariencia) })
      .eq('user_id', userId);
    return !error;
  } catch {
    return false;
  }
}
